module.exports = __webpack_public_path__ + "media/assets/background-images/hedge-legal-cf972329ebbf6bd0524c8b73169c661b.svg";